// extracted by mini-css-extract-plugin
export default {"checkout_summary":"ns","checkout_summary_wrapper":"os","summary_items":"ps","line_items_wrapper":"qs","separator":"rs","order_summary":"ss","line_item":"ts","order__summary_item_title":"us","recurringdis":"vs","note":"ws","carbon_emission":"xs","unlock_savings":"ys","member_perk":"zs","info":"As","no_items":"Bs","promo":"Cs","order_summary_mobile":"Es","open_summary_mobile":"Fs","fixed_bottom_info":"Gs","open_info":"Hs","text":"Is","open_summary":"Js"};
    if(module.hot) {
      // 1715188229683
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  